import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import type { ColumnsType } from 'antd/es/table';
import { Alert, FullWidthSpace, InputNumber, Row, Table, Title } from 'melco-ui';
import { MachineLicensesAssignmentButton } from './MachineLicensesAssignmentButton';
import { formatUTCDate } from '../../../helper/date/dateHelper';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';



//const expirationDate = '2025-12-31';



const Footer = styled.div`
  position: fixed; /* Changed from sticky to fixed */
  bottom: 0;
  width: 100%;
  background: #fff;
  padding: 16px 24px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  text-align: right;
  z-index: 10;
`;
const MachineLicenseAssignment: React.FC<{ assignmentData: any; callbackFn: () => void }> = ({ assignmentData, callbackFn }) => {
    // let { data: assignmentData } = useMachineLicenseGetAssignment()
    const [data, setData] = useState<any>();
    const { t } = useTranslation()
    console.log("Assignment Data ", JSON.stringify(assignmentData))
    //const expiringLicenses = assignmentData?.expiring_list?.[0]?.machine_subscription?.length ?? 0
    const [totalLicensesCount, setTotalLicensesCount] = useState(0)


    const [totalAssignedLicensesCount, setTotalAssignedLicensesCount] = useState(0);

    console.log("AssignedCounts", totalAssignedLicensesCount)

    //  Group expiring licenses by expiration_date
    const groupedExpirations: Record<string, number> = {};
    assignmentData?.expiring_list?.forEach((license: any) => {
        license.machine_subscription?.forEach((subscription: any) => {
            const date = formatUTCDate(subscription.expiration_date, "YYYY-MM-DD");
            groupedExpirations[date] = (groupedExpirations[date] || 0) + 1;
        });
    });

    // Expiring licenses info
    //    const expiringLicensesCount = assignmentData?.expiring_list?.[0]?.machine_subscription?.length ?? 0;
    //const expiringDate = assignmentData?.expiring_list?.[0]?.machine_subscription?.[0]?.expiration_date;

    // Optional: Format the date if using dayjs or similar
    //  const formattedExpiringDate = expiringDate ? formatUTCDate(expiringDate, "L") : null;

    const columns: ColumnsType<any> = [
        {
            title: t('machineLicenses.licenseAssignment.table.columns.licenseName'),
            //  dataIndex: 'display_name',
            key: 'display_name',
            render: (obj: any) => <>{obj?.display_name}</>
        },
        {
            title: t('machineLicenses.licenseAssignment.table.columns.assignedLicenses'),
            dataIndex: 'count',
            key: 'count',
            render: (_, record) => {
                const assignedCount = record.machine_subscription.length;
                const remainingLicenses = totalLicensesCount - totalAssignedLicensesCount;
                const maxForThisRow = assignedCount + remainingLicenses;

                // Keep initial assigned count in a ref or closure:
                const initialCount = assignedCount;

                return (
                    <InputNumber
                        min={0}
                        max={maxForThisRow}
                        value={assignedCount}
                        onChange={(value) => {
                            // When input is cleared (empty)
                            if (value === null || value === undefined || value === '') {
                                // Reset input to initial assigned count
                                // Force update by resetting data or re-rendering
                                // Here, we simply do nothing so value stays initialCount
                                return;
                            }

                            // If input is a string (not a number), ignore and reset
                            if (typeof value === 'string' || isNaN(Number(value))) {
                                // You can reset by calling setData or just ignore
                                return;
                            }
                            const numericValue = Number(value);

                            // Clamp numericValue within min/max
                            if (numericValue < 0) return;
                            if (numericValue > maxForThisRow) return;

                            const delta = numericValue - assignedCount;

                            if (delta > 0) {
                                for (let i = 0; i < delta; i++) {
                                    if (totalAssignedLicensesCount < totalLicensesCount) {
                                        handleIncrease(record.license_id);
                                    }
                                }
                            } else if (delta < 0) {
                                for (let i = 0; i < -delta; i++) {
                                    if (assignedCount > 0) {
                                        handleDecrease(record.license_id);
                                    }
                                }
                            }
                        }}
                        // Optionally add onBlur to reset on blur if needed
                        onBlur={() => {
                            // In case user left input empty, force reset UI by setting state
                            // Just call setData or trigger a state refresh if needed
                        }}
                    />
                );
            }
        },
    ];

    useEffect(() => {
        setData(assignmentData)

    }, [assignmentData])



    useEffect(() => {
        if (data) {
            const totalAssignedSubcriptions = data.assigned_list.reduce((total: number, item: any) => {
                return total + item.machine_subscription.length;
            }, 0);
            const totalAvailableSubscriptions = data.available_list?.[0]?.machine_subscription.length ?? 0;

            setTotalAssignedLicensesCount(totalAssignedSubcriptions);
            setTotalLicensesCount(totalAssignedSubcriptions + totalAvailableSubscriptions);
        }
    }, [data]);


    const handleIncrease = (licenseId: string) => {
        setData((prevData: any) => {
            // Clone the available machine subscriptions from the first item in available_list
            const available = [...(prevData.available_list?.[0]?.machine_subscription ?? [])];

            // No available licenses to assign
            if (available.length === 0) return prevData;

            // Get the first machine subscription from the available list
            const subscriptionToAssign = available.shift();

            // Update the assigned_list: Add the subscription to the matching license_id
            const updatedAssignedList = prevData.assigned_list.map((item: any) => {
                if (item.license_id === licenseId) {
                    return {
                        ...item,
                        machine_subscription: [...item.machine_subscription, subscriptionToAssign],
                    };
                }
                return item;
            });

            // Return new data structure with updated assigned and available lists
            return {
                ...prevData,
                assigned_list: updatedAssignedList,
                available_list: [{ machine_subscription: available }], // preserve structure
            };
        });
    };


    const handleDecrease = (licenseId: string) => {
        setData((prevData: any) => {
            let removedSubscription: any = null;

            // Update assigned_list: Remove the last subscription from the matching license
            const updatedAssignedList = prevData.assigned_list.map((item: any) => {
                if (item.license_id === licenseId && item.machine_subscription.length > 0) {
                    const newSubscriptions = [...item.machine_subscription];
                    // Remove the last assigned machine from this license
                    removedSubscription = newSubscriptions.pop();
                    return {
                        ...item,
                        machine_subscription: newSubscriptions,
                    };
                }
                return item;
            });

            // Clone the current available machine subscriptions
            const available = [...(prevData.available_list?.[0]?.machine_subscription ?? [])];

            // If we removed a machine, push it to the available list
            if (removedSubscription) {
                available.push(removedSubscription); // add it to the end
            }

            // Return updated data with preserved structure
            return {
                ...prevData,
                assigned_list: updatedAssignedList,
                available_list: [{ machine_subscription: available }], // preserve structure
            };
        });
    };


    return (
        <>

            <FullWidthSpace direction="vertical" size="middle">

                <Title level={4}>{t('machineLicenses.licenseAssignment.title')}</Title>
                <Alert type={"info"}
                    description={t('machinelicenses.licenseAssignment.summary.usedOutOfTotal',
                        {
                            defaultValue: `${totalAssignedLicensesCount} of ${totalLicensesCount} machine licenses used for SUMMIT Manager.`

                            , used: totalAssignedLicensesCount,
                            total: totalLicensesCount
                        }
                    )}
                    showIcon />

                {/* {expiringLicensesCount > 0 && (
                    <Alert
                        message={`Some licenses will expire soon, please remove them`}
                        description={`${expiringLicensesCount} licenses will expire at ${formattedExpiringDate}`}
                        type="warning"
                        showIcon
                        withBackground

                        style={{ marginBottom: 16 }}
                    />
                )} */}
                {Object.entries(groupedExpirations).length > 0 && (
                    <Alert
                        type="warning"
                        message={t('machineLicenses.licenseAssignment.warnings.someExpiring')}
                        //  Custom HTML description with grouped expiration details
                        description={
                            <ul style={{ margin: 0, paddingLeft: 20 }}>
                                {Object.entries(groupedExpirations)
                                    //  Sort expiration dates chronologically (oldest first)
                                    .sort(
                                        ([dateA], [dateB]) =>
                                            dayjs(dateA, "YYYY-MM-DD").unix() - dayjs(dateB, "YYYY-MM-DD").unix()
                                    )
                                    // Render each group: how many licenses expire on each date
                                    .map(([date, count]) => (
                                        <li key={date}>
                                            {t('machineLicenses.licenseAssignment.warnings.expiringDetails',
                                                {
                                                    defaultValue: `${count} license(s) will expire at ${formatUTCDate(date, "YYYY-MM-DD")}`,
                                                    count: count,
                                                    date: formatUTCDate(date, "YYYY-MM-DD")



                                                }
                                            )
                                            }
                                        </li>
                                    ))}
                            </ul>
                        }
                        showIcon
                        withBackground
                        style={{ marginBottom: 16 }}
                    />
                )}


                <Table
                    dataSource={data?.assigned_list}
                    columns={columns}
                    pagination={false}
                    bordered
                    rowKey="license_id"
                />

            </FullWidthSpace>


            <Footer>
                <Row>
                    <MachineLicensesAssignmentButton
                        assignmentData={data}

                        callbackFn={callbackFn}
                    />
                </Row>
            </Footer>
        </>);
};

export default MachineLicenseAssignment;